import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IAbacUserState {
  currentUserId: string;
}

export const abacUserIntitialState: IAbacUserState = {
  currentUserId: "",
};

export const AbacUserSlice = createSlice({
  name: "abacUser",
  initialState: abacUserIntitialState,
  reducers: {
    updateAbacUser: (state, action: PayloadAction<string>) => ({
      ...state,
      currentUserId: action.payload,
    }),
    resetAbacUser: (state) => ({ ...state, currentUserId: "" }),
  },
});
export const { updateAbacUser, resetAbacUser } = AbacUserSlice.actions;
export const selectAbacUser = (state: any) => state.abacUser;
export default AbacUserSlice.reducer;
